import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, useContext } from "react";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";
import MCaseView from "containers/Homeowner/MCaseView";
import responseHandler from "responseHandler";
import { userHasRight } from "selectors/rights";
import { CLOCK_IN_OR_OUT_FUNCTION } from "typeConstants/rights";
import { InitialState } from "reducers/initialState";
import { DialogProviderValue, DialogContext } from "components/Shared/DialogProvider";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface Props extends RouteComponentProps {
  callCenterReady: boolean,
  controlNumber: number,
  canClockInOut: boolean,
  activeClock: InitialState["user"]["activeClock"],
};

interface MCaseViewFormSet {
  title: string,
  id: string,
  formStatus: string,
};

const SchedulingAssistantView = ({
  callCenterReady,
  controlNumber,
  canClockInOut,
  activeClock,
  history,
}: Props) => {
  const mounted = useRef(true);
  const [sections, setSections] = useState<MCaseViewFormSet[]>([]);
  const dialog = useContext<DialogProviderValue>(DialogContext);

  useEffect(() => {
    let needsClockIn = canClockInOut && !(activeClock?.clockInDate);

    if (needsClockIn) {
      dialog.show(
        "Please Clock In",
        "You are not currently clocked in. Calls cannot be logged until you are clocked in. Please navigate to the My Time Logs page to clock in before starting your Call",
        [{ label: "My Time Logs", onClick: () => history.push("/sa-timelog"), isPrimary: true }],
        { width: 500 }
      );
    }

    getSections();
    return () => {
      mounted.current = false;
    };
  }, []);

  const getSections = () => {
    let _sections = [];
    _sections.push({
      title: "Case Details",
      id: "Header",
      formStatus: "clean",
    });
    _sections.push({
      title: "Case Actions",
      id: "Validation",
      formStatus: "clean"
    });
    _sections.push({
      title: "History",
      id: "History",
      formStatus: "clean"
    });
    _sections.push({
      title: "File Manager",
      id: "Files",
      formStatus: "clean"
    });
    _sections.push({
      title: "Photos",
      id: "Photos",
      formStatus: "clean",
    });
    setSections(_sections);
  };

  if (!callCenterReady || !mounted.current) {
    return (<div />);
  }
  if (callCenterReady && !controlNumber) {
    return (<MSpinner />);
  }  
  return (
    <div style={{ display:"flex", height: "100%" }}>
      <MCaseView
        externalFormSet={sections}
        controlNumberOverride={controlNumber}
      />
    </div>
  );
};

SchedulingAssistantView.propTypes = {
  controlNumber: PropTypes.number,
  rights: PropTypes.array,
  makeToast: PropTypes.func,
  callCenterReady: PropTypes.bool,
};

const mapStateToProps = state => ({
  controlNumber: Number(state.schedulingAssistant.currentControlNumber),
  callCenterReady: state.schedulingAssistant.callCenterReady,
  rights: state.user.profile.rights,
  canClockInOut: userHasRight(CLOCK_IN_OR_OUT_FUNCTION)(state),
  activeClock: state.user.activeClock,
});

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SchedulingAssistantView));
